import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { optimizedImage } from "../utils/images";
import "./PartnersSection.css";

const partners = [
	{
		name: "ABS",
		url: "https://activebulgariansociety.org/",
		logo: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758825385/abs_b8cblz.jpg",
	},
	{
		name: "Las Ninas Del Tul",
		url: "https://lasdeltul.net/",
		logo: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758825385/LogoMorado_k4fkwn.png",
	},
	{
		name: "TUA",
		url: "https://www.ua.gov.tr/",
		logo: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758825494/ulusalagent_tkbk6y.png",
	},
	{
		name: "IGEA",
		url: "https://igea.org.tr/",
		logo: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758825385/igeajpg_pe4jyv.jpg",
	},
	{
		name: "Erasmus+",
		url: "https://erasmus-plus.ec.europa.eu/",
		logo: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1758825385/erasmus_g1ymav.webp",
	},
	{
		name: "AESS",
		url: "https://economia-sustentavel.com/en/",
		logo: "https://res.cloudinary.com/dpuo4ow5h/image/upload/v1765619356/AESS_Short-Version_vlkr7u.png",
	},
];

const PartnersSection = () => (
    <section className="partners-section">
        <div className="partners-section-bg" />
        <div className="container">
            <motion.h2
                className="partners-title"
                initial={{ opacity: 0, y: 32 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.22, 0.9, 0.32, 1] }}
                viewport={{ once: true }}
            >
                Partners
            </motion.h2>
            <motion.p
				className="partners-lead"
				initial={{ opacity: 0, y: 16 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.7, delay: 0.1 }}
				viewport={{ once: true }}
			>
				We believe in the power of collaboration. Together with our partners
				across Europe and beyond, we create sustainable projects that drive real
				change.
			</motion.p>
			<div className="partners-logos-carousel-outer">
				<motion.div
					className="partners-logos-carousel"
					initial={{ x: 0 }}
					animate={{ x: ["0%", "-50%"] }}
					transition={{
						repeat: Infinity,
						repeatType: "loop",
						duration: 14,
						ease: "linear",
					}}
				>
					{[...partners, ...partners].map((partner, idx) => (
						<a
							href={partner.url}
							className="partner-logo-link"
							key={partner.name + idx}
							target="_blank"
							rel="noopener noreferrer"
							aria-label={partner.name}
						>
							<motion.img
								src={optimizedImage(partner.logo, 400)}
								alt={partner.name}
								className="partner-logo"
								loading="lazy"
								decoding="async"
								whileHover={{
									scale: 1.15,
									zIndex: 2,
									boxShadow: "0 8px 32px rgba(37,99,235,0.18)",
								}}
								transition={{ type: "spring", stiffness: 320, damping: 18 }}
							/>
						</a>
					))}
				</motion.div>
			</div>
			<motion.div
				className="partners-cta-wrap"
				initial={{ opacity: 0, y: 24 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.7, delay: 0.2 }}
				viewport={{ once: true }}
			>
                <Link to="/be-our-partner" className="team-section-cta">
                    Be Our Partner
                </Link>
            </motion.div>
		</div>
	</section>
);

export default PartnersSection;